import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

import MultiLineTextAreaField from 'components/MultiLineTextAreaField';
import VariantFieldSet from 'bento-ordering/base/components/VariantFieldSet';

const FREEFORM_VARIANT_LENGTH = '400';

function VariantFreeForm({ fieldName, helperText = '', title }) {
  return (
    <VariantFieldSet helperText={helperText} title={title}>
      <Field
        component={MultiLineTextAreaField}
        maxLength={FREEFORM_VARIANT_LENGTH}
        name={fieldName}
      />
    </VariantFieldSet>
  );
}

VariantFreeForm.propTypes = {
  fieldName: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  title: PropTypes.string.isRequired
};

export default VariantFreeForm;
